import { render, staticRenderFns } from "./stockCard.vue?vue&type=template&id=ea242db6&scoped=true&"
import script from "./stockCard.vue?vue&type=script&lang=js&"
export * from "./stockCard.vue?vue&type=script&lang=js&"
import style0 from "./stockCard.vue?vue&type=style&index=0&id=ea242db6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea242db6",
  null
  
)

export default component.exports